/**
 * Gemiye nihai liste ve mal kabulü (ADR 0115; ADR 0111 §E): gemide tedarikçi dizini, talep
 * kartında "Orders by Supplier", GRN'de stoğa girmeyen ve ikame satırları.
 */
export const purchasingShipEn = {
  directory: {
    title: 'Suppliers',
    description: 'Supplier directory of the company, received from the office.',
    readOnly:
      'Read only on board. Suppliers are managed in the office; bank, tax and commercial terms are not sent to the vessel.',
    table: 'Supplier directory',
    search: 'Search supplier, contact or city…',
    type: 'Type',
    allTypes: 'All types',
    country: 'Country',
    allCountries: 'All countries',
    status: 'Status',
    filter: {
      approved: 'Approved & active',
      all: 'All suppliers',
      inactive: 'Inactive',
      not_approved: 'Not approved',
    },
    statuses: { active: 'Active', inactive: 'Inactive', not_approved: 'Not approved' },
    columns: {
      name: 'Supplier Name',
      type: 'Type',
      location: 'Location',
      contact: 'Contact Person',
      phone: 'Phone',
      email: 'Email',
      status: 'Status',
      actions: 'Actions',
    },
    fields: {
      code: 'Supplier Code',
      address: 'Address',
      regions: 'Service regions',
      website: 'Website',
    },
    view: 'View {{name}}',
    close: 'Close',
    emptyTitle: 'No suppliers on board yet.',
    emptyText: 'The supplier directory arrives with the next synchronisation with the office.',
    noMatch: 'No supplier matches the filters.',
    error: 'The supplier directory could not be loaded.',
  },
  bySupplier: {
    tab: 'Orders by Supplier',
    empty: 'No purchase order yet.',
    emptyHint: 'Orders issued by the office for this requisition are listed here by supplier.',
    meta_one: '{{count}} order · {{lines}} items',
    meta_other: '{{count}} orders · {{lines}} items',
    table: 'Orders from {{name}}',
    columns: {
      po: 'PO No',
      item: 'Item',
      ordered: 'Ordered',
      received: 'Received',
      unitPrice: 'Unit Price',
      total: 'PO Total',
      status: 'Status',
    },
    substitute: 'Substitute',
    substituteFor: 'for {{name}}',
  },
  fulfilment: {
    substituteFor: 'Substitute for {{name}} · does not fulfil the requested item',
  },
  // Gemi satın alma fiyatını görmez (sahip kararı 2026-11-05; ADR 0169)
  prices: {
    hidden: 'Prices are visible in the office.',
  },
  grn: {
    stock: 'Stock',
    toStock: 'To stock',
    notStocked: 'Not stocked',
    substitute: 'Substitute for {{name}} · not stocked',
    substituteNote:
      'Substitute items are recorded on the GRN but are not booked to stock as the requested item.',
  },
  // Gemi panosu: onayımı bekleyen talepler (04.11 notları C4)
  approvals: {
    title: 'Requisitions awaiting approval',
    viewAll: 'All requisitions',
    pending_one: '{{count}} requisition awaits your decision',
    pending_other: '{{count}} requisitions await your decision',
    overdue_one: '{{count}} overdue',
    overdue_other: '{{count}} overdue',
    line: '{{department}} · {{requestedBy}}',
    step: 'Step {{step}} · since {{since}}',
    overdue: 'Overdue',
    open: 'Open {{no}}',
  },
};

export const purchasingShipTr: typeof purchasingShipEn = {
  directory: {
    title: 'Tedarikçiler',
    description: 'Şirketin tedarikçi dizini; ofisten iner.',
    readOnly:
      'Gemide salt okunur. Tedarikçiler ofiste yönetilir; banka, vergi ve ticari koşullar gemiye gönderilmez.',
    table: 'Tedarikçi dizini',
    search: 'Tedarikçi, kişi ya da şehir ara…',
    type: 'Tür',
    allTypes: 'Bütün türler',
    country: 'Ülke',
    allCountries: 'Bütün ülkeler',
    status: 'Durum',
    filter: {
      approved: 'Onaylı ve etkin',
      all: 'Bütün tedarikçiler',
      inactive: 'Pasif',
      not_approved: 'Onaysız',
    },
    statuses: { active: 'Etkin', inactive: 'Pasif', not_approved: 'Onaysız' },
    columns: {
      name: 'Tedarikçi Adı',
      type: 'Tür',
      location: 'Konum',
      contact: 'İlgili Kişi',
      phone: 'Telefon',
      email: 'E-posta',
      status: 'Durum',
      actions: 'İşlemler',
    },
    fields: {
      code: 'Tedarikçi Kodu',
      address: 'Adres',
      regions: 'Hizmet bölgeleri',
      website: 'Web sitesi',
    },
    view: '{{name}} ayrıntısı',
    close: 'Kapat',
    emptyTitle: 'Gemide henüz tedarikçi yok.',
    emptyText: 'Tedarikçi dizini ofisle bir sonraki senkronda iner.',
    noMatch: 'Süzgeçlere uyan tedarikçi yok.',
    error: 'Tedarikçi dizini yüklenemedi.',
  },
  bySupplier: {
    tab: 'Tedarikçiye Göre Siparişler',
    empty: 'Henüz sipariş yok.',
    emptyHint: 'Ofisin bu talep için verdiği siparişler burada tedarikçiye göre listelenir.',
    meta_one: '{{count}} sipariş · {{lines}} kalem',
    meta_other: '{{count}} sipariş · {{lines}} kalem',
    table: '{{name}} siparişleri',
    columns: {
      po: 'PO No',
      item: 'Kalem',
      ordered: 'Sipariş',
      received: 'Teslim Alınan',
      unitPrice: 'Birim Fiyat',
      total: 'PO Toplamı',
      status: 'Durum',
    },
    substitute: 'İkame',
    substituteFor: '{{name}} yerine',
  },
  fulfilment: {
    substituteFor: '{{name}} yerine ikame · istenen kalemi karşılamaz',
  },
  prices: {
    hidden: 'Fiyatlar ofiste görünür.',
  },
  grn: {
    stock: 'Stok',
    toStock: 'Stoğa girer',
    notStocked: 'Stoğa girmez',
    substitute: '{{name}} yerine ikame · stoğa girmez',
    substituteNote: 'İkame kalemler GRN’de kayda geçer ama istenen kalem olarak stoğa girmez.',
  },
  // Gemi panosu: onayımı bekleyen talepler (04.11 notları C4)
  approvals: {
    title: 'Onay bekleyen talepler',
    viewAll: 'Bütün talepler',
    pending_one: '{{count}} talep kararınızı bekliyor',
    pending_other: '{{count}} talep kararınızı bekliyor',
    overdue_one: '{{count}} süresi geçti',
    overdue_other: '{{count}} süresi geçti',
    line: '{{department}} · {{requestedBy}}',
    step: 'Adım {{step}} · {{since}} tarihinden beri',
    overdue: 'Süresi geçti',
    open: '{{no}} aç',
  },
};
